import BasicLayout from "@/layouts/basic-layout";

const meta = {
    auth: false,
    cache: false,
};
export default {
    path: "/bigKb",
    name: "bigKb",
    redirect: {
        name: "bigKb",
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: "/bigKb/maxKbHome",
            name: "maxKbHome",
            meta: {
                ...meta,
                title: "知识库",
            },
            component: () => import("@/pages/maxKb/index.vue"),
        },
    ],
};
